import { connect } from 'react-redux';
import ClientWrapper from "../components/general/ClientWrapper";
import { REMOVE_CLIENT } from "../store/actions/client";

const mapStateToProps = state => {
    return {
        
    };
};

const mapDispatchToProps = dispatch => {
    return {
        REMOVE_CLIENT: body => dispatch(REMOVE_CLIENT(body)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientWrapper);


// WEBPACK FOOTER //
// ./src/containers/Client.js